import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { useStyles } from '~/assets/styles';
import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import Typography from '~/components/core/Atomic/Typography';
import { TextFieldFormik } from '~/components/TextFieldFormik';

const CAP_TITLE = 'Recoveries exceed total paid';

interface CapWarningModalProps {
  message: string;
  onConfirm: (reason: string) => Promise<void>;
  onClose: () => void;
}

export const CapWarningModal: React.FC<CapWarningModalProps> = ({ message, onConfirm, onClose }) => {
  const { classes } = useStyles();
  return (
    <Formik
      initialValues={{ cap_override_reason: '' }}
      validationSchema={Yup.object().shape({
        cap_override_reason: Yup.string().trim().required('Required'),
      })}
      onSubmit={async (values, formikProps) => {
        try {
          await onConfirm(values.cap_override_reason.trim());
        } catch {
          formikProps.setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, handleSubmit }) => (
        <CardDialog isDialog open onClose={onClose} title={CAP_TITLE} preventClose={isSubmitting}>
          <div className={classes.textField}>
            <Typography>{message}</Typography>
          </div>
          <TextFieldFormik id="cap_override_reason" label="Reason" fullWidth className={classes.textField} />
          <div className={classes.buttonsContainer}>
            <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => handleSubmit()}>
              Confirm
            </Button>
          </div>
        </CardDialog>
      )}
    </Formik>
  );
};

interface CapBlockedModalProps {
  message: string;
  onClose: () => void;
}

export const CapBlockedModal: React.FC<CapBlockedModalProps> = ({ message, onClose }) => {
  const { classes } = useStyles();
  return (
    <CardDialog isDialog open onClose={onClose} title={CAP_TITLE}>
      <div className={classes.textField}>
        <Typography>{message}</Typography>
      </div>
    </CardDialog>
  );
};
